import {
  Grid2,
  Label,
  Scrollbar,
  SortableList,
} from '@aibees/shared/components';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useTransferListItems } from '../../hooks/use-transfer-list-items';
import useTransferListStore from '../../store/transfer-list-store';
import * as TransferListSX from '../../sx';
import { TransferListItem } from '../../types';
import { TransferItem } from '../transfer-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { TransferListIncludedProps as Props } from './types';

export const TransferListIncluded = memo(
  ({ title, requireAtLeastOne, requireAtLeastOneText }: Props) => {
    const { config, setIncluded } = useTransferListStore();
    const { included, excluded } = useTransferListItems();

    const handleChange = (items: TransferListItem[]) => {
      setIncluded(items.map((x) => x.id));
    };

    return (
      <Grid2 lg={6} xl={6} md={6} sm={12} sx={TransferListSX.rightContent}>
        <Grid2 container sx={TransferListSX.columnHeader}>
          <Grid2>
            <Typography variant="body3" fontWeight={600} color="grey.700">
              {title}
            </Typography>
          </Grid2>

          <Label
            variant="filled"
            color="primary"
            size="xxsmall"
            children={included.ids.length}
          />
        </Grid2>
        {requireAtLeastOne &&
          requireAtLeastOneText &&
          included.items.length === 0 && (
            <Stack sx={SX.requireWrapper}>
              <Typography sx={SX.requireText}>
                {requireAtLeastOneText}
              </Typography>
            </Stack>
          )}
        {!!included.items.length && (
          <Scrollbar sx={TransferListSX.scrollbar}>
            {config?.sortable ? (
              <SortableList
                items={included.items || []}
                onChange={(e) => handleChange(e)}
                renderItem={(x) => (
                  <TransferItem
                    key={x.id}
                    item={x}
                    includedIds={included.ids}
                    excludedIds={excluded.ids}
                  />
                )}
              />
            ) : (
              <Styled.Wrapper sx={SX.root}>
                {included.items.map((x, index) => (
                  <TransferItem
                    key={index}
                    item={x}
                    includedIds={included.ids}
                    excludedIds={excluded.ids}
                  />
                ))}
              </Styled.Wrapper>
            )}
          </Scrollbar>
        )}
      </Grid2>
    );
  }
);

TransferListIncluded.displayName = 'TransferListIncluded';
